import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { useLocation } from "react-router-dom";
import { X } from "lucide-react";
import api from "@/lib/api";

const FLAG = "tnt_journey_popup";
export const requestJourneyPopup = () => sessionStorage.setItem(FLAG, "1");

// Mounted once in Layout. When "Create Your Event" is clicked on the homepage the flag is set and the
// user navigates to /create-event as usual; here the infographic popup opens on top of the wizard.
export default function JourneyPopup() {
  const { pathname } = useLocation();
  const [cfg, setCfg] = useState(null);
  const [open, setOpen] = useState(false);
  useEffect(() => { api.get("/settings/journey-popup").then((r) => setCfg(r.data)).catch(() => setCfg({ enabled: false })); }, []);
  useEffect(() => {
    if (sessionStorage.getItem(FLAG) && pathname === "/create-event") {
      sessionStorage.removeItem(FLAG);
      setOpen(true);
    }
  }, [pathname]);
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => e.key === "Escape" && setOpen(false);
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open]);
  const enabled = !!(cfg?.enabled && cfg.image_url);
  if (!open || !enabled) return null;

  return createPortal(
    <div data-testid="journey-popup" className="fixed inset-0 z-[100] bg-[#292724]/85 backdrop-blur-sm flex items-end sm:items-center justify-center p-0 sm:p-8" onClick={() => setOpen(false)}>
      <div onClick={(e) => e.stopPropagation()} className="relative w-full sm:w-auto sm:max-w-5xl max-h-[94vh] flex flex-col bg-white rounded-t-3xl sm:rounded-3xl shadow-2xl overflow-hidden border border-[#d4af37]/30">
        <div className="flex items-center justify-between gap-4 px-5 sm:px-7 py-4 bg-[#292724]">
          <div className="min-w-0">
            <div className="eyebrow text-[#d4af37] text-[10px] mb-0.5">Tent N Tap</div>
            <div className="font-serif text-white text-lg sm:text-2xl font-light leading-tight truncate">Your Create Your Event journey</div>
          </div>
          <button type="button" aria-label="Close" data-testid="journey-popup-close" onClick={() => setOpen(false)}
            className="shrink-0 w-10 h-10 rounded-full border border-[#d4af37] text-[#d4af37] hover:bg-[#d4af37] hover:text-[#292724] flex items-center justify-center transition-colors">
            <X className="w-5 h-5" />
          </button>
        </div>
        <div className="overflow-auto bg-[#fcfaf8] p-3 sm:p-5">
          <img data-testid="journey-popup-image" src={cfg.image_url} alt="Your Tent N Tap journey"
            className="block mx-auto max-w-full max-h-[74vh] w-auto h-auto object-contain rounded-2xl" />
        </div>
      </div>
    </div>,
    document.body
  );
}
